<template>
  <span
    v-waypoint="{
      active: !done && animationPaused,
      callback: onWaypoint,
      options: intersectionOptions,
    }"
    v-bind="$attrs"
    v-on="$listeners"
    >{{ tweenedNumber }}</span
  >
</template>

<script>
// Returns the number of full stop in given string.
const countFullstops = (str) => str.replace(/[^.]/g, '').length

export default {
  name: 'NumberAnimated',
  props: {
    from: {
      type: [Number, String],
      default: 0,
    },
    to: {
      type: [Number, String],
      required: true,
      default: 0,
    },
    format: {
      type: Function,
      default: (num) => parseInt(num),
    },
    duration: {
      type: Number,
      default: 1, // Duration of animation in seconds
    },
    easing: {
      type: String,
      default: 'Power1.easeOut',
    },
    delay: {
      type: Number,
      default: 0, // Delay the animation in seconds
    },
    animationPaused: Boolean, // Stops animation before start
  },
  data() {
    return {
      fromProp: this.from,
      animation: null,
      animationReady: null,
      done: false,
      intersectionOptions: {
        root: null,
        rootMargin: '0px',
        threshold: [0, 1],
      },
    }
  },
  computed: {
    tweenedNumber() {
      return this.format(this.fromProp)
    },
  },
  watch: {
    to(newValue) {
      this.tween(newValue)
    },
  },
  mounted() {
    this.animationReady = this.tween(this.to)
  },
  methods: {
    async tween(value) {
      const { gsap } = await import('gsap' /* webpackChunkName: 'gsap' */)

      this.animation = gsap.to(this.$data, {
        fromProp: value,
        paused: this.animationPaused,
        ease: this.easeCheck(),
        onStart: () => this.$emit('start'),
        onComplete: () => {
          this.done = true
          this.$emit('complete')
        },
        onUpdate: () => this.$emit('update'),
        duration: this.duration,
        delay: this.delay, // In seconds
      })
    },
    async play() {
      await this.animationReady
      this.animation.play()
    },
    async pause() {
      await this.animationReady
      this.animation.pause()
    },
    async restart() {
      await this.animationReady
      this.animation.restart()
    },
    easeCheck() {
      if (countFullstops(this.easing) !== 1) {
        throw new Error('Invalid ease type. (eg. easing="Power1.easeOut")')
      }
      return this.easing
    },
    onWaypoint(waypoint) {
      if (this.done) return

      if (waypoint.going === this.$waypointMap.GOING_IN) {
        this.play()
      }
    },
  },
}
</script>
